module.exports = __webpack_public_path__ + "static/media/background_SWE.71d10e08.jpg";